import { render, staticRenderFns } from "./AdminUploadStudents.vue?vue&type=template&id=2051e3c6"
import script from "./AdminUploadStudents.vue?vue&type=script&lang=js"
export * from "./AdminUploadStudents.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports